import { loadFont as loadInter } from "@remotion/google-fonts/Inter";
import { loadFont as loadInterTight } from "@remotion/google-fonts/InterTight";

const inter = loadInter("normal", {
  weights: ["400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
});

const interTight = loadInterTight("normal", {
  weights: ["400", "500", "600", "700"],
  subsets: ["latin"],
});

/**
 * Use `fontFamily.inter` for body copy and `fontFamily.interTight` for
 * display / headline text. These are loaded through Remotion's
 * google-fonts helper so they are available during rendering.
 */
export const fontFamily = {
  inter: inter.fontFamily,
  interTight: interTight.fontFamily,
} as const;
